import { render, staticRenderFns } from "./GatewayPendingOrFailureDetails.vue?vue&type=template&id=3faa5047"
import script from "./GatewayPendingOrFailureDetails.vue?vue&type=script&lang=js"
export * from "./GatewayPendingOrFailureDetails.vue?vue&type=script&lang=js"
import style0 from "./GatewayPendingOrFailureDetails.vue?vue&type=style&index=0&id=3faa5047&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports